import React from 'react';
import styled, { css } from 'styled-components';
import mq from '../../utils/mq';
import Container from '../container';
import StatItem from '../logo-marquee-with-title-and-stats/StatItem';

const OuterContainer = styled.div<{
  $theme?: 'white' | 'grey' | 'darkGrey';
  $enablePaddingTop: boolean;
  $enablePaddingBottom: boolean;
}>`
  background-color: ${({ $theme }) =>
    $theme === 'white' ? '#fff' : $theme === 'grey' ? '#f8f8f8' : '#F5F5F5'};
  padding-top: ${({ $enablePaddingTop }) => ($enablePaddingTop ? '64px' : '0')};
  padding-bottom: ${({ $enablePaddingBottom }) =>
    $enablePaddingBottom ? '32px' : '0'};
  margin-bottom: ${({ $enablePaddingBottom }) =>
    $enablePaddingBottom ? '0px' : '-32px'};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $enablePaddingTop }) =>
    $enablePaddingTop &&
    css`
      ${mq.mobile(css`
        padding-top: 32px;
      `)}
    `}
  ${({ $enablePaddingBottom }) =>
    $enablePaddingBottom &&
    css`
      ${mq.mobile(css`
        padding-bottom: 32px;
        margin-bottom: 0px;
      `)}
    `}
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 48px;
  align-items: start;
  ${mq.mobile(css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  `)}
`;

export default function StatsSection({
  statItems,
  theme,
  enablePaddingTop,
  enablePaddingBottom
}: {
  statItems: any[];
  theme: 'white' | 'grey' | 'darkGrey';
  enablePaddingTop: boolean;
  enablePaddingBottom: boolean;
}) {
  return (
    <OuterContainer
      $theme={theme}
      $enablePaddingTop={enablePaddingTop}
      $enablePaddingBottom={enablePaddingBottom}
    >
      <Container>
        <StatsContainer>
          {statItems.map((stat) => (
            <StatItem key={stat.id} {...stat} smallVariant />
          ))}
        </StatsContainer>
      </Container>
    </OuterContainer>
  );
}
